module.exports = {
    disabled: 0,
    delay: 1000,
    body: {
        delayed: '1 seconds',
        data: { a: 11, b: 22, id: 1 },
        msg: '',
        status: 0
    }
}
